import { startOfDay } from 'date-fns';

import { ID_FOCA } from '@data/constants/Eventos';

const date = startOfDay(new Date());

export const EventoInterface = {
  imgURL: '',
  imgMovilURL: '',
  files: [],

  idPartido: 1, // No se usa en front
  idAmbito: 5,
  AmbitoValor: 1,

  idTipoActividad: 7,
  Actividad: '',
  Descripcion: '',
  FechaInicio: '',
  FechaFin: '',

  idEsPara: 1,
  idPlantillaQR: 1,
  idModalidad: 1,
  NombreLugar: '',
  Calle: '',
  NumExt: '',
  NumInt: '',
  Colonia: '',
  idMunicipio: 1,
  LigaVirtual: '',

  esConcurrente: false,
  diasConcurrentes: [],

  tienePreguntas: false,
  preguntas: [],

  TienePreregistro: 1,
  FechaFinPreregistro: '',

  noSesiones: 1,
  sesiones: [],

  coordenadas: { latitud: null, longitud: null },

  /* // No se usan en front
  
  LinkPreregistro: null,
  textoPreregistro: null,

  isPrivado: null,
  idModoEvento: null,
  TieneAsistenciaQR: null,
  shortUrlAsistencia: null,
  */
};

export const EventoEditInterface = {
  idEvento: 96,
  idEstatus: 1,

  imgURL: '',
  imgMovilURL: '',
  files: [],

  idPartido: 1, // No se usa en front
  idAmbito: 5,
  AmbitoValor: 1,

  idTipoActividad: 7,
  Actividad: '',
  Descripcion: '',
  FechaInicio: '',
  FechaFin: '',

  idEsPara: 1,
  idPlantillaQR: 1,
  idModalidad: 1,
  NombreLugar: '',
  Calle: '',
  NumExt: '',
  NumInt: '',
  Colonia: '',
  idMunicipio: 1,
  LigaVirtual: '',

  tienePreguntas: false,
  preguntas: [],

  TienePreregistro: 1,
  FechaFinPreregistro: '',

  noSesiones: 1,
  sesiones: [],

  coordenadas: { latitud: null, longitud: null },
};

export const EventoPreguntasInterface = {
  idEvento: 0,
  preguntas: [],
};

export const EventosFilter = {
  actividad: '',
};

export const EventosInvitadosFilter = {
  celular: '',
};

export const CompromisoEventInterface = ({ idEvento = '', type = 0, idModoEvento = 2, isMenor = 0 }) => ({
  idEvento: idEvento,
  idModoEvento: idModoEvento,

  token: '',
  answers: [],

  account: {
    // Username: '', // Se añade al final (copiando el cellphone)
    Password: '',
    Confirm: '',
    PIN: '',
  },
  user: {
    isMenor,
    Nombre: '',
    Paterno: '',
    Materno: '',
    FechaNacimiento: '',
    idSexo: '',
    idEstadoNacimiento: '',

    INE: '',
    VigenciaINE: '',
    SeccionVota: '',

    CURP: '', // Cuando isMenor = true
    // EsMilitante: '', // Cuando isBasic = true
  },
  contact: {
    Celular: '',
    Telefono: '',
    TelMensajes: '',
    Correo: '',
  },
  address: {
    TipoVialidad: 'C', // al final se une con CalleVive
    CalleVive: '',
    NumExtVive: '',
    NumIntVive: '',
    idEntidadVive: 11,
    idMunicipioVive: '',
    idLocalidadVive: '',
    ColoniaVive: '',
    CPVive: '',
  },
  social: {
    facebook: '',
    instagram: '',
    tiktok: '',
    x: '',
  },
  academy: {
    idGrade: '',
    generalEducation: '',
  },

  ...(type === ID_FOCA
    ? {
        employment: {
          idWork: '',
          occupation: '',
          workplace: '',
        },
        formation: {
          foundBy: '',
          topics: [],
          days: [],
          initialDate: date,
          finalDate: date,
          idParticipate: 0,
          participateProyect: '',
          participateDescription: '',
        },
        invitation: {
          idInvite: 0,
          idTrainer: 0,
          branch: '',
        },
      }
    : {}),

  extras: {
    idPartido: 1,
    idUsuarioPropietario: 1,
    idEstructuraSocial: 1,
    medioConfirmacion: 'sms',
  },
  volunteer: {
    EsVoluntario: null,
    idVoluntario: null,
    idDeseaParticipar: null,
  },
});

export const CompromisoBasicEventExternoInterface = (idEvento = '') => ({
  Nombre: '',
  Paterno: '',
  Materno: '',

  EsMilitante: '',

  idMunicipioVive: '',

  Celular: '',
  Telefono: '',
  TelMensajes: '',

  idEvento: idEvento,

  answers: [],
});

export const PlantillasInterface = {
  Titulo: '',
  idTipo: '',
  files: [
    {
      file: '',
    },
  ],
};
